// Still used by the journey builder (ConfigDrawer.jsx) only — journeys are on
// the old stub sending pipeline (see HANDOFF.md) and weren't in scope for the
// segment/campaign builder's move to live ClickHouse-backed options.
export const APP_EVENTS = [
  'app_install', 'app_open', 'screen_view', 'button_click', 'search',
  'app_update', 'notification_received', 'notification_opened', 'deep_link_opened',
  'lead_added', 'earning_initiated', 'task_submitted',
  'kyc_initiated', 'kyc_submitted', 'kyc_approved', 'kyc_rejected',
];

// Legacy fixed presets — still used by the journey builder's (unsupported)
// logic-condition node. The segment builder's own time window is a free
// number + unit pair now (see TIME_WINDOW_UNITS) rather than picked from here.
export const TIME_WINDOWS = [
  { label: 'last 1 hour', value: 1, unit: 'hours' },
  { label: 'last 6 hours', value: 6, unit: 'hours' },
  { label: 'last 24 hours', value: 24, unit: 'hours' },
  { label: 'last 7 days', value: 7, unit: 'days' },
  { label: 'last 14 days', value: 14, unit: 'days' },
  { label: 'last 30 days', value: 30, unit: 'days' },
  { label: 'last 60 days', value: 60, unit: 'days' },
  { label: 'last 90 days', value: 90, unit: 'days' },
  { label: 'last 6 months', value: 6, unit: 'months' },
];

// Must match what the backend's queryBuilder/timeWindow.util accepts exactly.
export const TIME_WINDOW_UNITS = ['hours', 'days', 'weeks', 'months'];

// The backend only supports "did the event at all" or "did it more than N
// times" — no "exactly"/"at most". Trimmed rather than offering options that
// would silently do the wrong thing.
export const COUNT_OPS = ['at least'];

// Event properties are arbitrary per-event data, not a fixed catalog — any
// event can carry any property (e.g. lead_added: { source: "referral" },
// button_click: { button_id: "btn_12" }). So the property name is free text
// here, not a dropdown sourced from a schema.
export const PROPERTY_OPS = ['equals', 'not equals', 'in', 'not in', 'greater than', 'less than', 'is set', 'is not set'];

export const FILTER_TYPES = {
  event: {
    label: 'Event',
    col: 'rgba(184,66,66,.13)',
    tc: '#C86060',
  },
  'event-performed': {
    label: 'Did',
    col: 'rgba(79,155,111,.13)',
    tc: '#63B887',
  },
  'event-not-performed': {
    label: 'Did Not',
    col: 'rgba(160,124,48,.13)',
    tc: '#C09848',
  },
  // props/valsByProp for these two are discovered live from ClickHouse (see
  // segmentService.getOptions / FilterRow.jsx) — not hardcoded here.
  'user-property': {
    label: 'Profile',
    col: 'rgba(72,120,176,.13)',
    tc: '#6090C8',
    ops: ['equals', 'not equals'],
  },
  'entity-status': {
    label: 'Status',
    col: 'rgba(122,110,176,.13)',
    tc: '#A09AC8',
    ops: ['equals', 'not equals'],
  },
  earning: {
    label: 'Earning',
    col: 'rgba(79,155,111,.12)',
    tc: '#63B887',
    // "Any" sums across every earning entity_type instead of scoping to one —
    // e.g. "earned ₹500 anywhere" rather than "earned ₹500 from Projects".
    // 'Project'/'Game' each group two raw entity_types (JOB+JOB_TASK,
    // GAME+GAME_PARTICIPATION_ROUND — see EARNING_TYPE_BY_PROP in
    // segmentConditions.js) so the sum matches the same category
    // earningSync.job.js's event_name labeling already uses. 'Payout' isn't
    // an entity_type at all (a reversal can carry any of them) — it's backed
    // by an auto-added subentity_type property filter instead, see
    // segmentConditions.js's filterToCondition/conditionsToFilters.
    props: ['Any', 'Project', 'Game', 'General', 'TL Earning', 'Referral', 'Tax', 'Payout'],
    ops: ['≥'],
    needsTimeWindow: true,
    numericValue: true,
  },
  // props/ops aren't used the generic way the other property-like types are
  // (props list, plain value dropdown) — this gets its own dedicated render
  // block in FilterRow.jsx (campaign picker + status + Did/Did Not), same
  // reasoning the 'event' type already gets one.
  campaign: {
    label: 'Campaign',
    col: 'rgba(160,124,48,.12)',
    tc: '#C09848',
  },
};
